module.exports = __webpack_public_path__ + "static/door-787cc0baa47de69baf067d943f61ae54.jpg";